module.exports = __webpack_public_path__ + "img/gallery-11.eb4a4a88.png";